var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactiveReviewFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5V6.75C10.5 5.50736 9.49264 4.5 8.25 4.5H7.25C6.83579 4.5 6.5 4.16421 6.5 3.75V2.75C6.5 1.50736 5.49264 0.5 4.25 0.5H3M6.48744 9.48744L7.5 10.5M4.5 0.5H1.25C0.835786 0.5 0.5 0.835786 0.5 1.25V12.25C0.5 12.6642 0.835786 13 1.25 13H9.75C10.1642 13 10.5 12.6642 10.5 12.25V6.5C10.5 3.18629 7.81371 0.5 4.5 0.5ZM7 8.25C7 9.2165 6.2165 10 5.25 10C4.2835 10 3.5 9.2165 3.5 8.25C3.5 7.2835 4.2835 6.5 5.25 6.5C6.2165 6.5 7 7.2835 7 8.25Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveReviewFilter);
export default __webpack_public_path__ + "static/media/deactive-review-filter.2f0364805677e6926bda4330c4f87e59.svg";
export { ForwardRef as ReactComponent };